import definition from 'lms_definition';
global.app.sdk.lms = global.app.create_sdk(definition, true);
//only work in test mode